import { getNextTypography, Hidden, makeStyles, Typography } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import classNames from 'classnames'
import React from 'react'

const useStyles = makeStyles(
  (theme: Theme) => ({
    label: {
      ...getNextTypography(theme).sectionTitle,
      lineHeight: 1.2,
      '@media print': {
        display: 'none'
      }
    },
    // White on the navy Item band, the same treatment `HideAmountButton` gets there.
    onDark: {
      color: theme.paintscout.palette.brand.Neutral.White
    }
  }),
  { name: 'AmountHeaderLabel' }
)

/**
 * The right-aligned amount label in an outlined table header (e.g. the currency symbol "£" / "$" or
 * "hr"), styled to match the header title. Hidden on small screens, mirroring the old table heads.
 * Pass `onDark` on the navy Item band, where the default slate text would be unreadable.
 */
export default function AmountHeaderLabel({
  children,
  onDark
}: {
  children: React.ReactNode
  /** Render for a dark header (navy Item band): white text. */
  onDark?: boolean
}) {
  const classes = useStyles()
  return (
    <Hidden smDown implementation="css">
      <Typography component="span" className={classNames(classes.label, { [classes.onDark]: onDark })}>
        {children}
      </Typography>
    </Hidden>
  )
}
